module.exports = __webpack_public_path__ + "img/logo.c1cc7427.jpg";